import context from '@/context'
import getComponentKey from '@/utils/getComponentKey'
import commonErrorHandler from '@/utils/errors'
const handleError = (details) => commonErrorHandler(actionTypes.ReportTemplateFileError, details)

const initialState = {
  adding: false,
  removing: false,
  entityIdBeingActivated: null,
  attachmentsKey: getComponentKey(),
  gridKey: getComponentKey()
}

export const actionTypes = {

  ReportTemplateFileAdding: 'reportTemplateFile/adding',
  ReportTemplateFileAdded: 'reportTemplateFile/added',
  ReportTemplateFileRemoving: 'reportTemplateFile/removing',
  ReportTemplateFileRemoved: 'reportTemplateFile/removed',
  ReportTemplateFileActivating: 'reportTemplateFile/activating',
  ReportTemplateFileActivated: 'reportTemplateFile/activated',
  ReportTemplateFileError: 'reportTemplateFile/error'
}

export const actionCreators = {
  addAttachments: (input) => (dispatch, getState) => {
    dispatch({ type: actionTypes.ReportTemplateFileAdding })
    context.api.reportTemplateFileService.addAttachments(input)
      .then(response => {
        dispatch({ type: actionTypes.ReportTemplateFileAdded })
      })
      .catch(error => handleError({ dispatch, error, update: { adding: false } }))
  },
  removeAttachments: (input) => (dispatch, getState) => {
    dispatch({ type: actionTypes.ReportTemplateFileRemoving })
    context.api.reportTemplateFileService.removeAttachments(input)
      .then(response => {
        dispatch({ type: actionTypes.ReportTemplateFileRemoved })
      })
      .catch(error => handleError({ dispatch, error, update: { removing: false } }))
  },
  activate: (input) => (dispatch, getState) => {
    dispatch({ type: actionTypes.ReportTemplateFileActivating, data: input })
    context.api.reportTemplateFileService.activate(input)
      .then(response => {
        dispatch({ type: actionTypes.ReportTemplateFileActivated })
      })
      .catch(error => handleError({ dispatch, error, update: { entityIdBeingActivated: null } }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ReportTemplateFileAdding: return { ...state, adding: true }
    case actionTypes.ReportTemplateFileAdded: return { ...state, adding: false, attachmentsKey: getComponentKey(), gridKey: getComponentKey() }
    case actionTypes.ReportTemplateFileRemoving: return { ...state, removing: true }
    case actionTypes.ReportTemplateFileRemoved: return { ...state, removing: false, gridKey: getComponentKey() }
    case actionTypes.ReportTemplateFileActivating: return { ...state, entityIdBeingActivated: action.data.entityId }
    case actionTypes.ReportTemplateFileActivated: return { ...state, entityIdBeingActivated: null, gridKey: getComponentKey() }

    case actionTypes.ReportTemplateFileError: return { ...state, ...action.data }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/ReportTemplateFile.js